import { emptyApi } from "./emptyApi";

export type GroupAiToggleResponse = {
  is_ai_enabled: boolean;
  ai_disabled_by: string | null;
};

export const groupAiToggleApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    toggleGroupAi: build.mutation<GroupAiToggleResponse, { groupId: string }>({
      query: ({ groupId }) => ({
        url: `/api/inkle/company/group/${groupId}/ai/toggle/`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "TeamSettingGroups", id: "TEAM" },
        { type: "Groups" },
      ],
    }),
  }),

  overrideExisting: false,
});

export const { useToggleGroupAiMutation } = groupAiToggleApi;
